/**
 * RPDM W1-D · /projects/:id top-level dispatcher.
 *
 * With master + summary_landing flags BOTH on -> render the RPDM
 * summary landing (new W1-D surface).
 * Otherwise -> render the existing ProjectDetail execution surface
 * BYTE-IDENTICAL to today.
 *
 * This is the single point that decides between the pre-W1-D world
 * and the W1-D world at the top of the projects namespace.
 */
import { useRpdmWorkspaceGate } from "@/hooks/useRpdmWorkspaceGate";
import ProjectDetail from "../ProjectDetail";
import ProjectSummaryLanding from "./ProjectSummaryLanding";

export default function ProjectRootDispatcher() {
    const gates = useRpdmWorkspaceGate();
    if (gates.summaryLanding) {
        return <ProjectSummaryLanding />;
    }
    return <ProjectDetail />;
}
